module.exports = __webpack_public_path__ + "img/btn-error.ce6b86df.gif";